/**
 * 组件的emit事件声明
 */
export const emits = [
  /** 点击遮罩层时触发 */
  'clickOverlay',
];
